import { CURRENCY } from "../balanceAPI/values"
import { IUserBalance } from "../balanceAPI/balance.types"

export enum SaleChestType {
  WEAPON = "weapon",
  JEWELRY = "jewelry"
}

export interface ISaleChestRange {
  startNumber: number
  endNumber: number
  chance: number
}

export interface ISaleChest {
  _id: string
  type: SaleChestType
  priceUSD: number
  priceStars: number
  priceTON: number
  totalLimit: number
  remainingCount: number
  adminRemovedCount: number
  lastChestNumber: number
  ranges: ISaleChestRange[]
  imgSrc?: string
  createdAt: string
  updatedAt: string
}

export interface ISaleChestPackage {
  size: number
  discount: number
  bonusChestType: string | null
  bonusChestImgSrc?: string
}

export interface ISaleChestConfig {
  _id: string
  packages: ISaleChestPackage[]
  publicStartAt: string
  createdAt: string
  updatedAt: string
}

export interface ISaleChestInstance {
  _id: string
  ownerId: string
  chestId: string
  type: SaleChestType
  chestNumber: number
  paymentMethod: string
  paidAmount: number
  purchasedAt: string
}

export interface IMySaleChestInstancesResponse {
  items: ISaleChestInstance[]
  total: number
}

export interface ICanPurchaseResponse {
  canPurchase: boolean
  reason?: string
  availableAt?: string
}

export interface IPurchaseRequest {
  chestId: string
  packageSize: number
  paymentMethod: CURRENCY.STAR | CURRENCY.TON
}

export interface IPurchaseResponse {
  invoiceLink?: string
  success?: boolean
  newBalance?: IUserBalance
}
